import { all, takeLatest, put, call } from 'redux-saga/effects';
import { getNotifications, updateNotification } from 'yoda-interfaces/lib/Account/AccountApi';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import * as NotificationActionTypes from '../actionTypes/NotificationDetailsActionTypes';

export function* getNotification(action) {
    const response = yield call(FactorySaga, getNotifications, action);
    const payload = {
        response: response.data || response.response.data,
    };
    payload.isLoading = false;
    if (response.isSuccess) {
        payload.isSuccess = true;
        yield put({ type: NotificationActionTypes.GET_NOTIFICATION_SUCCESS, payload });
    } else {
        payload.isSuccess = false;
        payload.error = response.data || response.response.data;
        yield put({
            type: NotificationActionTypes.GET_NOTIFICATION_ERROR,
            payload,
        });
    }
}

export function* changeNotification(action) {
    const response = yield call(FactorySaga, updateNotification, action);
    const payload = {
        response: action.payload,
    };
    payload.isLoading = false;
    payload.requestFrom = 'UPDATE';
    if (response.isSuccess) {
        payload.isSuccess = true;
        yield all([
            put({ type: NotificationActionTypes.UPDATE_NOTIFICATION_SUCCESS, payload }),
            put({ type: NotificationActionTypes.GET_NOTIFICATION }),
        ]);
    } else {
        payload.isSuccess = false;
        payload.error = response.response.data;
        yield put({
            type: NotificationActionTypes.UPDATE_NOTIFICATION_ERROR,
            payload,
        });
    }
}

function* watchNotificationSaga() {
    yield takeLatest(NotificationActionTypes.GET_NOTIFICATION, getNotification);
    yield takeLatest(NotificationActionTypes.UPDATE_NOTIFICATION, changeNotification);
}

watchNotificationSaga.sagaName = 'notificationSaga';
export default watchNotificationSaga;
